import { render, staticRenderFns } from "./BiTableCardApplications.vue?vue&type=template&id=3c971e08&"
import script from "./BiTableCardApplications.vue?vue&type=script&lang=js&"
export * from "./BiTableCardApplications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports